import React from 'react';

import d3 from '~/core/scripts/chart-components/d3';

export default ({ size = 50, data = [], colors = [] }) => {
  const pie = d3
    .pie()
    .value(d => d.value)
    .sort(null);

  const arc = d3
    .arc()
    .innerRadius(0)
    .outerRadius(size / 2);

  const pies = pie(data);

  return (
    <svg width={size} height={size}>
      <g transform={`translate(${size / 2},${size / 2})`}>
        {pies.map((p, i) => (
          <path key={i} d={arc(p)} fill={colors[i]} />
        ))}
      </g>
    </svg>
  );
};
